// platformPlaylist — shared internal helpers used by both types and services (I2 split).
import { SeqCounter } from "@djsem/shared";

const _seq = new SeqCounter();

/**
 * Generates a deterministic, sequential id with the given prefix (e.g. `"pl_1"`).
 * @param prefix - the id prefix to use.
 * @returns the generated id.
 */
export function id(prefix: string): string { return `${prefix}_${_seq.next()}`; }

/**
 * Normalizes a track/playlist title for fuzzy comparison: lowercases, strips `(feat. ...)` and
 * `(remix)` markers, quotes, and punctuation, and collapses whitespace.
 * @param s - the string to normalize, if present.
 * @returns the normalized string, or `""` if `s` is undefined/empty.
 */
export function normalize(s: string | undefined): string {
  if (!s) return "";
  return s.toLowerCase()
    .replace(/\(feat\.?[^)]*\)/gi, "")
    .replace(/\(remix\)/gi, "")
    .replace(/[''"`]/g, "")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
